// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Tooltip } from 'ui_kit_qmd'
import './visitRemarksCardItem.scss'
import { parseUserDateTime } from '../../utils/common'
import { EditToolPopUp } from '../edit-tool-pop-up/EditToolPopUp'
import { useEditRemarksPopupConfig } from './hooks/useEditRemarksPopupConfig'
import editDots from '../../images/charts/editDots.png'
import { useClickEventListener } from './hooks/useClickEventListener'

const VisitRemarksCardItem = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    message,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    author,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    role,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    index,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZoneAbbr,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    remarkId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditAllowed,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isFormOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEdited,
  }) => {
    const [isEditToolPopupOpened, setIsEditToolPopupOpened] = useState(false)
    console.log('isEditAllowed', isEditAllowed)
    useClickEventListener({ remarkId, setIsEditToolPopupOpened })

    const editRemarksPopupConfig = useEditRemarksPopupConfig({ setIsEditToolPopupOpened, remarkId })

    const toggleEditToolPopupVisibility = () => {
      setIsEditToolPopupOpened((prev) => !prev)
    }

    return (
      <section className='visit-remarks-card-item-container'>
        <div className='visit-remarks-card-item-author-container'>
          <Tooltip content={author} targetId={`visit-remarks-card-${index}`}>
            <div id={`visit-remarks-card-${index}`} className='visit-remarks-card-item-author bold'>
              {author}
            </div>
          </Tooltip>
          {role ?
            <div className='visit-remarks-card-item-author-role bold'> ({role})</div>
          : null}
          {isEditAllowed && !isFormOpened ?
            <div className='visit-remarks-card-item-edit-tool-pop-up-block'>
              <img
                role='presentation'
                onClick={toggleEditToolPopupVisibility}
                className='alert-card-tools'
                id={`dots${remarkId}`}
                src={editDots}
                alt='editDots'
              />
              {isEditToolPopupOpened ?
                <EditToolPopUp editToolPopUpOptions={editRemarksPopupConfig} />
              : null}
            </div>
          : null}
        </div>
        <span className='visit-remarks-card-item-date-of-creation'>
          {`${parseUserDateTime(dateTime, userTimeZone, true)} ${userTimeZoneAbbr}`}
          {isEdited ?
            <span> (Edited)</span>
          : null}
        </span>

        <span className='visit-remarks-card-item-message' dangerouslySetInnerHTML={{ __html: message }} />
      </section>
    )
  },
)

export default VisitRemarksCardItem
